<template>
  <div>
    <ul class="d-flex flex-wrap grid-favorite">
      <li class="file" v-for="(favorite,index) in listFavorite" v-bind:key="index">
        <div class="mypage__files">
          <div class="mypage__thumbnail">
            <img :src="favorite.icon_url" alt="" class="mypage__files__image">
            <div class="mypage__kindFile">
              <div class="mypage__iconList" v-if="isVideoAndImage(favorite.media_type_id)">
                <img src="@img/icon/icon-image.svg" alt="" v-if="isImage(favorite.media_type_id)">
                <img src="@img/icon/icon-video.svg" alt="" v-if="isVideo(favorite.media_type_id)">
              </div>
            </div>
          </div>
          <div class="mypage__files__title">{{truncate(favorite.name,8,'...')}}</div>
          <div class="mypage__files__datetime">{{dateFormat(favorite.updated_at)}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {MEDIA_TYPE} from '../../../utils/constant'

export default {
  name: 'GridFile',
  computed: {
    ...mapState({
      listFavorite: state => state.employeeMyPage.listFavorite
    })
  },
  methods: {
    isImage (value) {
      return value === MEDIA_TYPE.IMAGE_ROLE_ID
    },
    isVideo (value) {
      return value === MEDIA_TYPE.VIDEO_ROLE_ID
    },
    isVideoAndImage (mediaTypeId) {
      return mediaTypeId === MEDIA_TYPE.IMAGE_ROLE_ID || mediaTypeId === MEDIA_TYPE.VIDEO_ROLE_ID
    }
  },
  mounted () {
    this.$store.dispatch('employeeMyPage/getFavorite')
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/MyPage/GridFiles.vue